/**********************************************************************************************************
 *   BASE IMPORTS
 **********************************************************************************************************/
import { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'

/**********************************************************************************************************
 *   SHARED IMPORTS
 **********************************************************************************************************/
import { FrameInset } from '@nexigendigital/nxui'
import { useAppDispatch, useAppSelector } from 'store/hooks'
import { billingAPI } from 'api/billing'
import { shopAPI, useDeleteCartMutation } from 'api/shop'
import { setCheckoutStep } from 'store/slices/shopSlice'

import Complete from 'containers/shop/checkout/complete'
import CartConfirmation from 'containers/shop/checkout/cartConfirmation'

/**********************************************************************************************************
 *   COMPONENT START
 **********************************************************************************************************/
export default function OrderComplete() {
    const dispatch = useAppDispatch()
    const navigate = useNavigate()
    const { cart, order } = useAppSelector((state) => state.shop)
    const [deleteCart] = useDeleteCartMutation()

    useEffect(() => {
        if (!order) {
            navigate('/shop')
        }

        return () => {
            if (cart?.uuid) {
                deleteCart(cart.uuid)
                dispatch(setCheckoutStep('payment'))
                dispatch(shopAPI.util.resetApiState())
                dispatch(billingAPI.util.resetApiState())
            }
        }
    }, [order, cart])

    return (
        <FrameInset
            inset={'split'}
            location={{ pathname: '/Summary' }}
            left={{
                render: <Complete/>
            }}
            right={{
                render: <CartConfirmation/>
            }}
        />
    )
}
